import { postGenericMessage } from '../messages';
export * from './app';
export * from './routing';
export * from './store';
export * from './analytics';
export * from './messages';
export function getConfig(key) {
    const isBrowser = () => typeof window !== 'undefined';
    if (!isBrowser())
        return process.env[`NUXT_PUBLIC_${key}`] || process.env[`NUXT_${key}`];
    return (window.parent?.parent?.env?.[key] ||
        window.parent?.env?.[key] ||
        window.env?.[key] ||
        window.env?.[`VITE_${key}`] ||
        window.__NUXT__?.config?.public?.[key]);
}
export function emitMessageToParent({ message, data = {} }) {
    postGenericMessage({
        message,
        data,
    });
}
export function emitMessageToParentInSameIframe({ message, data = {} }) {
    postGenericMessage({
        message,
        data,
    }, true);
}
export function getAppContext() {
    return {
        appBusinessType: getConfig('APP_CONTEXT'),
        appFrontType: getConfig('CONTEXT_APP'),
        isFrontAgri: getConfig('CONTEXT_APP') === 'agri',
        isFrontTech: getConfig('CONTEXT_APP') === 'tech',
    };
}
//# sourceMappingURL=index.js.map